import { Feature, Polygon, Position } from "geojson";

import { Bounds, DrawCube, TwoDFlowData } from "../types";

export default function drawImage(data: {
  features: Feature[];
  twoDFlowData: TwoDFlowData;
  width: number;
  height: number;
  bounds: Bounds;
  minVelocity: number;
}) {
  const { features, twoDFlowData, bounds, width, height, minVelocity } = data;
  const speedXArray: number[] = [];
  const speedYArray: number[] = [];

  // Calculate bounds of features and add speeds to arrays
  const drawCubes = features
    .map((feature: Feature, index) => {
      const speedX = twoDFlowData.ucx[index];
      const speedY = twoDFlowData.ucy[index];

      if (!speedX && !speedY) return null;

      speedXArray.push(Math.abs(speedX));
      speedYArray.push(Math.abs(speedY));

      if (Math.sqrt(Math.abs(speedX) ** 2 + Math.abs(speedY) ** 2) < minVelocity) return null;

      return {
        coordinates: (feature.geometry as Polygon).coordinates[0],
        speedX,
        speedY,
      };
    })
    .filter((cube) => cube) as DrawCube[];

  if (!drawCubes.length) return null;

  // Calculate max speed on x and y axis postive and negative
  const maxSpeedX = (speedXArray.reduce((a, b) => a + b, 0) / speedXArray.length) * 2;
  const maxSpeedY = (speedYArray.reduce((a, b) => a + b, 0) / speedYArray.length) * 2;

  const canvas = new OffscreenCanvas(Math.floor(width), Math.floor(height));
  const ctx = canvas.getContext("2d") as unknown as CanvasRenderingContext2D;
  if (!ctx) return;
  ctx.globalCompositeOperation = "lighter";

  const totalDistanceX = bounds[2] - bounds[0];
  const totalDistanceY = bounds[3] - bounds[1];

  // Make cube for every feature
  drawCubes.forEach((cube: DrawCube) => {
    const { coordinates, speedX, speedY } = cube;

    // 0 is max speed left, 255 is max speed right
    const r = (255 * (speedX + maxSpeedX)) / (2 * maxSpeedX); // Right

    // 0 is max speed down, 255 is max speed up
    const g = (255 * (speedY + maxSpeedY)) / (2 * maxSpeedY); // Up

    // TODO: MAKE USE OF ACTUAL AMOUNT
    // 0 is max drop rate 255 is min drop rate
    const b = 127.5; // Amount

    ctx.fillStyle = "rgba(" + r + "," + g + "," + b + ",1)";

    ctx.beginPath();
    coordinates.forEach((coordinate: Position, index: number) => {
      const distanceFromLeft = coordinate[0] - bounds[0];
      const distanceFromTop = coordinate[1] - bounds[1];

      const xPoint = Math.floor((distanceFromLeft * width) / totalDistanceX);
      const yPoint = Math.floor((distanceFromTop * height) / totalDistanceY);

      if (index === 0) return ctx.moveTo(xPoint, yPoint);
      if (index === coordinates.length - 1) return ctx.closePath();
      ctx.lineTo(xPoint, yPoint);
    });
    ctx.fill();
  });

  const speed = 20;
  const windData = {
    image: canvas,
    height: height,
    width: width,
    uMin: -speed, // u left
    uMax: speed,
    vMin: -speed, // v down
    vMax: speed,
  };

  return windData;
}
